import React, { useCallback } from 'react';
import { Copy } from 'lucide-react';
import UiTooltip from '../ui/Tooltip';
import EventStatusBadge from './EventStatusBadge';
import EventActionsMenu from './EventActionsMenu';
import { getEventStatus } from '../../utils/eventHelpers';
import { formatDate } from '../../utils/formatDate';
import styles from './EventsTable.module.css';

const APP_URL = window.location.origin;

export default function EventsTable({
    events, onOpenEvent, onQr, onEdit, onDelete, onDuplicate, onTransfer, onExportCsv, onToast,
    deletingId, exportingEventId, duplicatingEventId,
}) {
    const copy = useCallback(async (text, label) => {
        try {
            await navigator.clipboard.writeText(text);
            onToast(`${label} copied!`);
        } catch {
            onToast('Copy failed');
        }
    }, [onToast]);

    return (
        <div className={styles.eventsTableWrap}>
            <table className={styles.eventsTable}>
                <thead>
                    <tr>
                        <th>Event</th>
                        <th>Status</th>
                        <th>Dates</th>
                        <th>Code</th>
                        <th className={styles.thActions}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {events.map((event) => {
                        const status = getEventStatus(event);
                        const joinUrl = `${APP_URL}/join/${event.code}`;
                        return (
                            <tr key={event.id} className={styles.tableRow}>
                                <td>
                                    <button
                                        type="button"
                                        className={styles.tableEventName}
                                        onClick={() => onOpenEvent(event.id)}
                                    >
                                        {event.name}
                                    </button>
                                </td>
                                <td>
                                    <EventStatusBadge status={status} />
                                </td>
                                <td className={styles.tableDates}>
                                    {formatDate(event.start_date) || '—'}
                                    {event.end_date && <> → {formatDate(event.end_date)}</>}
                                </td>
                                <td>
                                    <span className={styles.tableCode}>#{event.code}</span>
                                    <UiTooltip title="Copy code" placement="top">
                                        <button
                                            type="button"
                                            className={styles.tableCopyBtn}
                                            onClick={(e) => { e.stopPropagation(); copy(event.code, 'Code'); }}
                                            aria-label="Copy event code"
                                        >
                                            <Copy size={12} />
                                        </button>
                                    </UiTooltip>
                                </td>
                                <td className={styles.tdActions}>
                                    <EventActionsMenu
                                        event={event}
                                        onEdit={onEdit}
                                        onDelete={onDelete}
                                        onDuplicate={onDuplicate}
                                        onTransfer={onTransfer}
                                        onExportCsv={onExportCsv}
                                        deletingId={deletingId}
                                        exportingEventId={exportingEventId}
                                        duplicatingId={duplicatingEventId}
                                        onQr={() => onQr(event)}
                                        onCopyLink={() => copy(joinUrl, 'Join link')}
                                        onOpenEvent={() => onOpenEvent(event.id)}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
